import { h } from 'preact';

import { Provider } from 'react-redux';
import { useState } from 'preact/hooks';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';

import Header from './header/header.jsx';
import Main from './main/main.jsx';
import Sidebar from './sidebar/sidebar.jsx';
import getStore from '../store/index.js';
import SearchContext from '../context/useSearchContext.jsx';

const store = getStore();

const mdTheme = createTheme({
  typography: {
    fontSize: 14,
  },
});

function Dashboard(_props) {
  const [searchText, setSearchText] = useState('');
    
  return (
    <div id="preact_root">
      <Provider store={store}>
        <ThemeProvider theme={mdTheme}>
          <SearchContext.Provider value={{ searchText, setSearchText }}  >
            <Box sx={{ display: 'flex' }}>
              <CssBaseline />
              <Header />
              <Sidebar />
              <Main />
            </Box>
          </SearchContext.Provider>
        </ThemeProvider>
      </Provider>
    </div>
  );
}

export default Dashboard;
